// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/produkte/zahnradachse/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteZahnradachseDE: PageEntry = {
  id: "example.produkte-zahnradachse",
  locale: "de",
  slug: "produkte/zahnradachse",
  seo: {
    title: "Zahnradachse | Dietz GmbH",
    description: "Übertragen von Rotationsbewegungen im Interieurbereich von Fahrzeugen, Bsp. Mittelkonsole, Staufächer",
  },
  type: "post",
  h1: "Zahnradachse",
  intro: "Übertragen von Rotationsbewegungen im Interieurbereich von Fahrzeugen, Bsp. Mittelkonsole, Staufächer",
  blocks: [
    { kind: "image", src: "/images/live/DTZ-zahnradachsejpg.jpg", alt: "Zahnradachse", width: 1280, height: 1024 },
    { kind: "paragraph", text: "Aufgabe: die Verbindung von Kunststoff und Metall sicherzustellen, sodass trotz Drehbewegung diese Kombination beständig bleibt." }
  ],
};
